export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6898.38f0d5c7.jpg";